Elements = require '../elements'

module.exports =
class SplashSequence

  constructor: ->
    @$navIndicator = Elements.$navIndicator
    @$navMore      = Elements.$navMore
    @$menuBtn      = Elements.$menuBtn
    @$copyright    = Elements.$copyright

  getInitialVals: =>
    [
      {
        e: [ @$navIndicator, @$navMore, @$menuBtn, @$copyright ]
        p: { display: 'none' }
      }
    ]

  getSequences: =>
    {
      splash: [
        {
          e: @$navIndicator.add @$navMore
          p: { opacity: [ 0, 0 ] }
          o: { duration: 0, display: 'block' }
        }
        {
          e: @$navIndicator.eq 3
          p:
            opacity: [ 1, 1 ]
            scale  : [ 1, 0 ]
          o: { duration: 500, easing: 'easeOutBack' }
        }
        {
          e: @$navIndicator.eq 0
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, 90 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navIndicator.eq 1
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, 60 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navIndicator.eq 2
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, 30 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navIndicator.eq 4
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, -30 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navIndicator.eq 5
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, -60 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navIndicator.eq 6
          p:
            opacity   : [ 1, 1 ]
            translateY: [ 0, -90 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$navMore
          p:
            opacity: [ 1, 1 ]
            scale  : [ 1, 0 ]
            rotateZ: [ 0, 90 ]
          o: { duration: 500, easing: 'easeOutBack', sequenceQueue: false }
        }
        {
          e: @$menuBtn
          p: { scale: [ 1, 0 ] }
          o: { duration: 500, easing: 'easeOutBack', display: 'block', sequenceQueue: false }
        }
        {
          e: @$copyright
          p:
            scale  : [ 1, 0 ]
            rotateZ: [ 0, -90 ]
          o: { duration: 500, easing: 'easeOutBack', display: 'block', sequenceQueue: false }
        }
      ]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/splash-sequence.coffee